// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"925f852e","223":"fa62fea0","302":"339bd154","496":"ef0690d8","653":"be8d210c","742":"e6e2117c","753":"6fb991c8","809":"8c8561c1","890":"97dbc030","952":"9cc91ed5","989":"c28a8d49"}[chunkId] + ".chunk.css";
};